import InsightsCaughtUp from '@static/images/empty-state/insights-caught-up.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { StreamFilterTabs } from '~/views/stream/components/stream-type-tab-line/StreamTypeTabLine';

import * as S from './NoEvents.styles';

export const NoEvents = ({ activeTab }: { activeTab: StreamFilterTabs }) => {
  const { t } = useTranslation(['whatsNew']);

  const title = t(`whatsNew:noEventsInPastWeek_${activeTab}`);

  return (
    <S.Root data-testid="overview-event-feed-no-insights">
      <InsightsCaughtUp width="56px" height="56px" />
      <S.DescriptionText>
        <S.TitleText>{title}</S.TitleText>
      </S.DescriptionText>
    </S.Root>
  );
};
